import { render } from "./LikeButton.vue?vue&type=template&id=306ab6c1&scoped=true"
import script from "./LikeButton.vue?vue&type=script&lang=js"
export * from "./LikeButton.vue?vue&type=script&lang=js"

import "./LikeButton.vue?vue&type=style&index=0&id=306ab6c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306ab6c1"]])

export default __exports__